'use client'

import { useContext } from 'react'
import { ConfigContext, useTranslation } from '../../../context/ConfigContext'
import {
  getIsBraceletMyMove,
  getIsInStock,
  isSellingProductOnline,
} from '../../../utils/Product.utils'
import { useIsMobileOrTablet } from '../../../utils/screen.utils'
import { Button } from '../../Button/Button'
import ProductGetNotifyInStock from '../ProductGetNotifyInStock'
import {
  ProductConfigurationDeliveryWording,
  ProductConfigurationMaybeOnStore,
} from './ProductConfigurationCta.utils'
import OrderByPhoneCta from './OrderByPhoneCta'
import Loader from '../../Loader/Loader'
import ContactConciergerieCta from './ContactConciergerieCta'

const ProductConfigurationCtaConfigurableProduct = ({
  product,
  selectedVariant,
  isCarving = false,
  onSubmit,
  productOption,
  isLoading = false,
}: {
  product: Product
  selectedVariant: Variant | null
  isCarving?: boolean
  onSubmit: () => void
  productOption?: number
  isLoading: boolean
}) => {
  const isTablet = useIsMobileOrTablet()
  const t = useTranslation()
  const { isEcommerce } = useContext(ConfigContext)
  const isOnStock = !!(selectedVariant?.product && getIsInStock(selectedVariant.product))

  const isBraceletMyMove = getIsBraceletMyMove(product)
  const configurableIsSelling = selectedVariant?.product
    ? isSellingProductOnline(selectedVariant.product, isEcommerce())
    : isSellingProductOnline(product, isEcommerce())

  if (!configurableIsSelling) {
    if (product.isFineJewelry || selectedVariant?.product?.isFineJewelry) {
      return (
        <ContactConciergerieCta />
      )
    }
    return (
      <>
        <OrderByPhoneCta product={product} />
      </>
    )
  }

  if (product.stock_status === 'Loading') {
    return (
      <div>
        <Loader small />
      </div>
    )
  }

  if (!selectedVariant || (isBraceletMyMove && !productOption)) {
    return (
      <>
        {isTablet && (
          <div className='complet-options'>{t('catalog-product-mymove-requirement', {}, true)}</div>
        )}
        <Button
          isLoading={isLoading}
          classname='small black'
          label={t('Add to Cart', {}, false)}
          style='dark'
          type='submit'
          disabled
        />
        <ProductConfigurationDeliveryWording isCarving={isCarving} />
      </>
    )
  }

  if (isOnStock) {
    return (
      <>
        <Button
          isLoading={isLoading}
          classname='small black'
          label={t('Add to Cart', {}, false)}
          style='dark'
          type='submit'
          onClick={onSubmit}
        />
        <ProductConfigurationDeliveryWording isCarving={isCarving} />
      </>
    )
  }

  // alert stock
  if (isTablet) {
    return (
      <>
        <ProductConfigurationMaybeOnStore />
        <ProductGetNotifyInStock product={selectedVariant?.product || product} />
      </>
    )
  }

  return (
    <>
      <ProductGetNotifyInStock product={selectedVariant?.product || product} />
      <ProductConfigurationMaybeOnStore />
    </>
  )
}

export default ProductConfigurationCtaConfigurableProduct
